export enum BlockedClientEnum {
    ALL_CLIENTS = 'Todos',
    BLOCKED = 'Bloqueados',
    NOT_BLOCKED = 'Não bloqueados',
}

export type BlockedClient = 'ALL_CLIENTS' | 'BLOCKED' | 'NOT_BLOCKED';
